const addPromoCodeEle = document.querySelector('.add-promo-code');

if (addPromoCodeEle) {
  // Remove All Active Class and Set Default Item
  const defaultItemSet = (parent) => {
    parent.classList.remove('is-active');
    const inputEle = parent.querySelector('.add-promo-code__input');
    const inputEleParent = parent.querySelector('.add-promo-code__input-wrapper');
    const codeEle = parent.querySelector('.add-promo-code__code');
    inputEleParent.classList.remove('is-focused');
    if (inputEle.value) {
      inputEle.value = '';
      codeEle.innerHTML = '';
    }
  };
  const promoCodeSuccess = (pricesHtml, shippingIndicatorHtml, deliveryPrices, response) => {
    if (response?.data?.data?.analytics_cart) {
      localData.analyticsCart = response.data.data.analytics_cart;
    }
    const shippingIndicatorEl = document.querySelector('.free-shipping-indicator');
    const cartSummaryEl = document.querySelector('.cart-module__sidebar-cart-summary');
    const ppCartSummaryEl = document.querySelector('.purchase-process-prices');
    const ppDeliveryFormEl = document.querySelector('#sc-purchase-process-info-02');
    if (shippingIndicatorEl) {
      shippingIndicatorEl.outerHTML = shippingIndicatorHtml;
    }
    if (cartSummaryEl) {
      cartSummaryEl.innerHTML = pricesHtml;
    }
    if (ppCartSummaryEl) {
      ppCartSummaryEl.innerHTML = pricesHtml;
    }
    updateLoyaltyCard(response.data.data.loyalty_card_html);
    if (ppDeliveryFormEl) {
      deliveryPrices.forEach((deliveryPrice) => {
        const price = ppDeliveryFormEl
          .querySelector(`[id="${deliveryPrice.delivery_type}"]`)
          ?.closest('.purchase-process-dropdown__header')
          ?.querySelector('.checkbox__info-price');
        if (price) {
          price.textContent = deliveryPrice.delivery_price;
        }
      });
    }
    if (response.data.data.shipping) {
      localData.shipping = response.data.data.shipping;
      response.data.data.shipping.forEach((delivers) => {
        document.querySelectorAll('input[name="delivery"]').forEach((deliveryChecks) => {
          if (deliveryChecks.id === delivers.id) {
            deliveryChecks
              .closest('.purchase-process-dropdown__header')
              .querySelector('.checkbox__info-price').textContent = delivers.amountText;
          }
        });
      });
    }
  };

  const promoCodeError = (parent, message) => {
    parent.classList.add('is-validation-failed');
    const errorMessage = parent.querySelector('.add-promo-code__error-message');
    errorMessage.innerHTML = message;
  };

  // Remove Active Class
  const removeActiveClass = (array) => {
    array.forEach((element) => {
      element.closest('.add-promo-code__item-init').classList.remove('is-active');
      element.innerHTML = '';
    });
  };

  // Check if Vouchers got removed
  const checkIfVouchersGotRemoved = () => {
    const encodedCookie = Cookies.get('vouchers');
    const voucherElements = document.querySelectorAll('.add-promo-code--voucher.is-active .add-promo-code__code');
    if (encodedCookie) {
      const cookieArray = JSON.parse(encodedCookie);
      const voucherElementsArray = Array.prototype.slice.call(voucherElements);
      const voucherElementsToDelete = voucherElementsArray.filter((element) => {
        const matchFound = cookieArray.some((cookie) => cookie.code === element.innerHTML);
        return !matchFound;
      });
      removeActiveClass(voucherElementsToDelete);
    } else {
      removeActiveClass(voucherElements);
    }
  };

  // Axios Calculate Totals
  const axiosCalculateTotals = async () => {
    const formDataInput = new FormData();
    formDataInput.append('action', 'calculateTotals');
    formDataInput.append('lang', localData.lang);
    try {
      await axios.post(localData.siteURL, formDataInput, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    } catch (err) {
      console.error(err);
    }
  };

  // Axios Remove Promo Code
  const axiosRemovePromoCode = async (promoCode, element, action) => {
    const formDataInput = new FormData();
    formDataInput.append('action', action);
    formDataInput.append('promo_code', promoCode);
    formDataInput.append('lang', localData.lang);
    try {
      const response = await axios.post(localData.siteURL, formDataInput, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      defaultItemSet(element);
      promoCodeSuccess(
        response.data.data.cart_prices_html,
        response.data.data.free_shipping_indicator_html,
        response.data.data.delivery_prices,
        response,
      );
      document.dispatchEvent(new CustomEvent('loyaltyDiscountRemoved', { detail: { code: promoCode } }));
      await axiosCalculateTotals();
      if (document.querySelector('.sc-purchase-process-info-02')) {
        reInitPayMethods();
      }
    } catch (err) {
      promoCodeError(element, err.response.data.data.error_message);
    }
  };

  // Axios Add Promo Code
  const axiosAddPromoCode = async (promoCode, element, action) => {
    const formDataInput = new FormData();
    formDataInput.append('action', action);
    formDataInput.append('promo_code', promoCode);
    formDataInput.append('lang', localData.lang);
    try {
      const response = await axios.post(localData.siteURL, formDataInput);
      element.classList.remove('is-validation-failed');
      if (action === 'addCouponCode') {
        defaultItemSet(element);
      } else {
        element.classList.add('is-active');
      }
      promoCodeSuccess(
        response.data.data.cart_prices_html,
        response.data.data.free_shipping_indicator_html,
        response.data.data.delivery_prices,
        response,
      );
      if (document.querySelector('.sc-purchase-process-info-02')) {
        reInitPayMethods();
      }
      axiosCalculateTotals();

      if (action === 'addCouponCode') {
        checkIfVouchersGotRemoved();
      }
    } catch (err) {
      promoCodeError(element, err.response.data.data.error_message);
    }
  };

  // Submit Code
  attachEvent('.btn--add-promo-code__submit', 'click', (ev) => {
    const parentEle = ev.target.closest('.add-promo-code__item-init');
    const promoCodeInput = parentEle.querySelector('.add-promo-code__input').value.replace(/(<([^>]+)>)/gi, '');
    const codeEle = parentEle.querySelector('.add-promo-code__code');
    const isVoucher = parentEle.classList.contains('add-promo-code--voucher');
    const isCoupon = parentEle.classList.contains('add-promo-code--coupon');

    if (promoCodeInput.length < 1) {
      return;
    }

    if (!/^[a-zA-Z0-9-]+$/.test(promoCodeInput)) {
      parentEle.classList.add('is-validation-failed');
      return;
    }

    codeEle.innerHTML = promoCodeInput;

    if (isVoucher) {
      axiosAddPromoCode(promoCodeInput, parentEle, 'addVoucerCode');
    }

    if (isCoupon) {
      axiosAddPromoCode(promoCodeInput, parentEle, 'addCouponCode');
    }
  });

  // Remove Code
  attachEvent('.add-promo-code__button--remove', 'click', (ev) => {
    const parentEleRemove = ev.target.closest('.add-promo-code__item-init');
    const codeEl = parentEleRemove.querySelector('.add-promo-code__code');
    const codeToRemove = codeEl.dataset.code || codeEl.innerHTML;
    const isVoucherRemove = parentEleRemove.classList.contains('add-promo-code--voucher');
    const isCouponRemove = parentEleRemove.classList.contains('add-promo-code--coupon');

    if (isVoucherRemove) {
      axiosRemovePromoCode(codeToRemove, parentEleRemove, 'removeVoucerCode');
    }

    if (isCouponRemove) {
      axiosRemovePromoCode(codeToRemove, parentEleRemove, 'removeCouponCode');
    }
  });

  // Remove Coupon/Voucher Tag (checkout sidebar price breakdown)
  attachEvent('.tag__close', 'click', async (ev) => {
    const button = ev.target.closest('.tag__close');
    const { code: promoCode, type } = button.dataset;

    if (!promoCode || type !== 'coupon' || button.disabled) return;

    button.disabled = true;

    const formDataInput = new FormData();
    formDataInput.append('action', 'removeCouponCode');
    formDataInput.append('promo_code', promoCode);
    formDataInput.append('lang', localData.lang);

    try {
      const response = await axios.post(localData.siteURL, formDataInput, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      promoCodeSuccess(
        response.data.data.cart_prices_html,
        response.data.data.free_shipping_indicator_html,
        response.data.data.delivery_prices,
        response,
      );
      document.dispatchEvent(new CustomEvent('loyaltyDiscountRemoved', { detail: { code: promoCode } }));
      await axiosCalculateTotals();
    } catch (err) {
      console.error(err);
      button.disabled = false;
    }
  });

  // Add Input
  attachEvent('.add-promo-code__button--add', 'click', (ev) => {
    const parentEle = ev.target.closest('.add-promo-code__item');
    const innerEle = parentEle.querySelector('.add-promo-code__item-init');
    const sentClone = innerEle.cloneNode(true);
    parentEle.appendChild(sentClone);
    defaultItemSet(sentClone);
    inputFocus();

    // Remove Code Input
    const removeInput = sentClone.querySelector('.add-promo-code__button--remove');
    removeInput.addEventListener('click', (ele) => {
      const parentDiv = ele.target.closest('.add-promo-code__item-init');
      parentDiv.remove();
    });
  });

  // Add Input
  attachEvent('.add-promo-code__input', 'input', (ev) => {
    const parentElem = ev.target.closest('.add-promo-code__item-init');
    if (ev.target.value.length < 1) {
      parentElem.classList.remove('is-validation-failed');
    }
  });
}
